import { Splitter } from 'antd';
import { messageMenu } from '@/configs/router/menu';
import Paths from '@/configs/router/paths';
import MessageHeader from './components/messageHeader';
import { SplitterMsgData } from './type';
import styles from './index.module.scss';

const Messages = () => {
  const [cacheMsgTypes, setCacheMsgTypes] = useState<string[]>([]);
  const location = useLocation();
  const params = useParams();

  useLayoutEffect(() => {
    if (
      location.pathname &&
      !cacheMsgTypes.includes(location.pathname) &&
      location.pathname.includes(Paths.MESSAGES_PATH)
    ) {
      setCacheMsgTypes((oldCacheMsgTypes) => [...oldCacheMsgTypes, location.pathname]);
    }
  }, [location.pathname, params.type, cacheMsgTypes]);

  return (
    <Splitter className={styles.messages}>
      <Splitter.Panel
        defaultSize={SplitterMsgData.DEFAULT_SIZE_AND_MIN}
        min={SplitterMsgData.SIZE}
      >
        <MessageHeader></MessageHeader>
        {messageMenu?.map((item) => {
          if (cacheMsgTypes.includes(item.key as string)) {
            return (
              <div
                className={styles.msgSider}
                key={item.key}
                hidden={item.key !== location.pathname}
              >
                {item.siderElement}
              </div>
            );
          }
          return null;
        })}
      </Splitter.Panel>
      <Splitter.Panel min={SplitterMsgData.SIZE}>
        {messageMenu?.map((item) => {
          if (cacheMsgTypes.includes(item.key as string)) {
            return (
              <div
                className={styles.msgContainer}
                key={item.key}
                hidden={item.key !== location.pathname}
              >
                {item.element}
              </div>
            );
          }
          return null;
        })}
      </Splitter.Panel>
    </Splitter>
  );
};
export default Messages;
